import type { Model } from '@patsnap/tahiti-core';
import type { EmbodimentRule } from '../types';

export const EmbodimentRulesModel = Symbol.for('EmbodimentRulesModel');

export interface EmbodimentRulesModel extends Model<EmbodimentRule[]> {}
